import {
  PartialFlagsAdminV1SegmentInput,
  SegmentFragment,
  UpdateSegmentMutation,
  useUpdateSegmentMutation,
  withStandardUpdateHook,
} from '@spotify/confidence-graphql';

export const useUpdateSegment = withStandardUpdateHook<
  UpdateSegmentMutation,
  SegmentFragment,
  'updateSegment',
  PartialFlagsAdminV1SegmentInput
>(useUpdateSegmentMutation, 'updateSegment');
